import React from 'react';
import { Box, Container, Typography, Link, Grid } from '@mui/material';

function Footer() {
  return (
    <Box sx={{ backgroundColor: 'primary.dark', color: 'white', py: 6, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom sx={{ color: 'accent.goldenYellow' }}>
              Székelyföldi Földtani Társulat
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              A székelyföldi geológiai örökség kutatása, védelme és népszerűsítése.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} sx={{ textAlign: { md: 'right' } }}>
            <Typography variant="h6" gutterBottom sx={{ color: 'accent.goldenYellow' }}>
              Kapcsolat
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              Email: info@szft.ro<br />
              Partnereink: <Link href="https://szno.ro" color="inherit">szno.ro</Link>
            </Typography>
          </Grid>
        </Grid>
        <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', mt: 4, pt: 2, textAlign: 'center' }}>
          <Typography variant="caption" sx={{ opacity: 0.6 }}>
            © {new Date().getFullYear()} Székelyföldi Földtani Társulat. Minden jog fenntartva.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
